module.exports = __webpack_public_path__ + "assets/524ef429833568a751bd25b17586b5e4.mp3";